import { MenuItem, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import { useMenuClose } from "@/dentlab/src/components/custom-button-with-anchored-menu/custom-button-with-anchored-menu.component";

export const CustomMenuItem: FC<{
	title: string | boolean;
	menuFunction: () => void;
	text: string;
	placement?: "right" | "left";
	disabled?: boolean;
	dataTestId?: string;
	onClose?: () => void;
}> = ({ title, placement, dataTestId, menuFunction, disabled, text, onClose }) => {
	const contextOnClose = useMenuClose();
	const handleClose = onClose ?? contextOnClose;
	
	const handleClick = () => {
		menuFunction();
		handleClose?.();
	};

	return (
		<Tooltip title={title} placement={placement}>
			<div data-testid={dataTestId}>
				<MenuItem
					onClick={handleClick}
					sx={{ pl: "20px" }}
					disabled={disabled}
				>
					<Typography textAlign="center">{text}</Typography>
				</MenuItem>
			</div>
		</Tooltip>
	);
};
